const contactDetails = [
  {
    group: "Location",
    icon: "ri-map-pin-2-line",
    items: [
      { label: "Address", value: "15 NOVEMBAR BB" },
      { label: "City", value: "Presevo" },
      { label: "Zip", value: "637237" },
      { label: "Country", value: "Serbia" },
    ],
  },
  {
    group: "Get in Touch",
    icon: "ri-message-3-line",
    items: [
      { label: "Email", value: "help@nuradoo.com" },
      { label: "Number", value: "+1 5074805413" },
    ],
  },
];

export default function ContactSection() {
  return (
    <section id="contact" className="py-32 bg-gray-950 text-white relative overflow-hidden">
      {/* Decorative background */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 rounded-full bg-cyan-500/5 blur-3xl" />
        <div className="absolute bottom-0 right-1/4 w-96 h-96 rounded-full bg-teal-500/5 blur-3xl" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-8">
        {/* Header */}
        <div className="flex flex-col items-center text-center mb-20">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-px w-8 bg-cyan-500" />
            <span className="text-cyan-400 text-xs uppercase tracking-[0.25em] font-medium">Contact</span>
            <span className="h-px w-8 bg-cyan-500" />
          </div>
          <h2
            className="text-4xl md:text-5xl font-light text-white leading-tight"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            Reach out to <span className="font-semibold text-cyan-400">NURA DOO</span>
          </h2>
          <p className="text-gray-400 mt-4 max-w-md text-base leading-relaxed">
            Have a question about our iOS products? Our team is ready to help.
          </p>
        </div>

        {/* Contact cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-3xl mx-auto">
          {contactDetails.map((group) => (
            <div
              key={group.group}
              className="rounded-2xl bg-white/5 border border-white/10 p-8 backdrop-blur-sm"
            >
              <div className="flex items-center gap-3 mb-6">
                <div className="w-10 h-10 flex items-center justify-center rounded-xl bg-cyan-500/15 text-cyan-400">
                  <i className={`${group.icon} text-lg`} />
                </div>
                <h3
                  className="text-base font-semibold text-white"
                  style={{ fontFamily: "'Space Grotesk', sans-serif" }}
                >
                  {group.group}
                </h3>
              </div>
              <ul className="flex flex-col gap-4">
                {group.items.map((item) => (
                  <li key={item.label} className="flex items-start gap-3">
                    <span className="text-gray-500 text-sm w-16 flex-shrink-0 pt-0.5">{item.label}:</span>
                    <span className="text-gray-200 text-sm font-medium">{item.value}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="mt-20 pt-10 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <span
            className="text-white font-bold text-lg tracking-[0.18em]"
            style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          >
            NURA DOO
          </span>
          <p className="text-gray-500 text-sm">
            &copy; {new Date().getFullYear()} NURA DOO. All rights reserved.
          </p>
          <p className="text-gray-600 text-xs">iOS Applications &mdash; Serbia</p>
        </div>
      </div>
    </section>
  );
}
